import type { CategoryDefinition } from '@/types';

export const electricianCategories: readonly CategoryDefinition[] = [
  { id: 'electrician.installation', name: 'Installation', icon: 'lightbulb',   color: 'amber',  order: 1, description: 'Fittings priced per point' },
  { id: 'electrician.wiring',       name: 'Wiring',       icon: 'cable',       color: 'orange', order: 2, description: 'Circuits and cable runs' },
  { id: 'electrician.repair',       name: 'Repair',       icon: 'wrench',      color: 'slate',  order: 3, description: 'Faults, boards and replacements' },
  { id: 'electrician.inspection',   name: 'Inspection',   icon: 'badge-check', color: 'blue',   order: 4, description: 'Testing and certification' },
  { id: 'electrician.emergency',    name: 'Emergency',    icon: 'siren',       color: 'rose',   order: 5, description: 'Same-day attendance' },
];
